import React, { useEffect, useState } from "react";
import { Dropdown} from "antd";
import "./FilterPopup.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Search from "../../Inputs/Search/Search";
import AccessControl from "components/HOC/AccessControl/AccessControl";
import { FeatureSettingsFlagTypes, roleCheckTypes } from "utils/constants/constants";
import { FilterInfo } from "utils/models";
type FilterPopupSubTabType = {
  id: string;
  idType: "static" | "dynamic";
  title: string;
  condition?:FilterInfo
  icon: string; // Assuming icons are strings representing icon names
  hide?:boolean;
};
type FilterPopupTabType = {
  id: number;
  icon: string; // Assuming icons are strings representing icon names
  title: string;
  description: string;
  subtabs: FilterPopupSubTabType[];
  featureFlag?:typeof FeatureSettingsFlagTypes[keyof typeof FeatureSettingsFlagTypes];
  role?:keyof typeof roleCheckTypes
};

type propType = {
  data: FilterPopupTabType[];
  onItemClick: (data: { key: string ,condition?:FilterInfo}) => void;
  children: React.ReactElement;
};
function FilterPopup({ onItemClick, children, data=[] }: propType) {
  const [search, setSearch] = useState("");
  const [filteredItems,setFilteredItems]=useState<FilterPopupTabType[]>([])

  return (
    <>
    <AccessControl key={JSON.stringify(data)} items={data} getAccessedItems={(items:any)=>setFilteredItems(items)}><></></AccessControl>
    <Dropdown
      trigger={["click"]}
      placement="bottomLeft"
      overlay={
        <Tabs className="d-flex p-1 custom-filter-dropdown-tab">
          <TabList className="p-0 w-50 my-0 custom-filter-left-list">
            {filteredItems?.map((tab, index) => (
              <Tab
              className=" mx-0 mb-1 custom-filter-tab text-overflow-ellipsis"
              key={tab.id}
              onClick={() => {
                setSearch("");
              }}
              >
                <span className="d-flex m-2 cursor-pointer align-items-center">
                  <img
                    width={35}
                    height={35}
                    src={tab.icon}
                    alt={`${index}audiencePartIcon`}
                    ></img>{" "}
                  <div className="d-flex flex-column">
                    <span className="mx-1 custom-filter-tab-title">
                      {tab.title}
                    </span>
                    <span className="mx-1 text-overflow-ellipsis">
                      {tab.description}
                    </span>
                  </div>
                </span>
              </Tab>
            ))}
          </TabList>

          {filteredItems?.map((tab, index) => (
            <TabPanel  key={tab.id} className={"custom-filter-tab-panel"}>
              <Search
                className="mx-1 w-100 custom-filter-search"
                onChange={(e) => setSearch(e.target.value)}
                />
              <TabList  className="py-1 px-1 custom-filter-right-list w-100">
                {tab?.subtabs?.filter((subtab)=>!subtab.hide).map((subtab) =>
                   subtab?.title?.toLowerCase().includes(search?.toLowerCase()) ? (
                     <Tab
                     className="custom-filter-tab mx-0 text-overflow-ellipsis"
                     key={subtab.id}
                     onClick={() => onItemClick({ key: subtab.id,condition:subtab.condition})}
                     >
                      <span className="d-flex m-2 align-items-center cursor-pointer">
                        {subtab.icon ? (
                          <img
                          width={26}
                          height={26}
                          src={subtab.icon}
                          alt={`audiencePartIcon${index}`}
                          ></img>
                        ) : (
                          ""
                        )}
                        <span className="mx-1">{subtab.title}</span>
                      </span>
                    </Tab>
                  ) : (
                    <></>
                  )
                )}
              </TabList>
            </TabPanel>
          ))}
        </Tabs>
      }
      >
      {children}
    </Dropdown>
      </>
  );
}
export default FilterPopup;
